import React from 'react'
import ReactGA from 'react-ga'
import Button from '../../../../../../../shared/components/Button/Button'
import AdImg from '../../../../../../../assets/1557185301607.jpg'
import './Ad.scss'

const gotoJeffConnect = () => {
  ReactGA.event({
    category: 'Appt Request',
    action: 'Click to Login',
    label: 'JeffConnect'
  })
  window.location = 'https://www.jeffconnect.org/'
}

const Ad = () => (
  <div className="ad">
    <div className="title">JeffConnect</div>
    <div className="body">
      <div>
        <div className="sub-title">The Faster, Easier Way to See a Doctor – by Video!</div>
        <div className="text">Welcome to JeffConnect<span style={{ verticalAlign: 'super', fontSize: '60.0%', lineHeight: '100.0%' }}>®</span>, a service that ‘connects’ you with our doctors — anytime, anywhere — through your cell phone, tablet or computer with a webcam. We use the latest video technology to deliver face-to-face care and consultation, without you having to come to Jefferson.</div>
        <div className="login">
          <Button
            className="login-btn"
            color="blue-fill"
            onClick={gotoJeffConnect}
          >Login. See a Doctor Now.</Button>
        </div>
      </div>
      <div>
        <img
          src={AdImg}
          alt="jeffconnect-main"
        />
      </div>
    </div>
  </div>
)

export default Ad
